// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2HEJm","emails":"CreateEditClinics_emails__1dBkq","emailTagLabel":"CreateEditClinics_emailTagLabel__TF5nf"};